import BursaryLayout from './BursaryLayout';
import { useEffect, useState } from 'react';
import M from 'materialize-css/dist/js/materialize.min';
import { FaSearch } from 'react-icons/fa';
import { connect } from 'react-redux';
import { compose } from "redux";
import { firestoreConnect } from "react-redux-firebase";
import { Link } from 'react-router-dom';

const StudentSearch = ({ students }) => {
    const [ surname, setSurname ] = useState('');
    const [ programme, setProgramme ] = useState('');
    const [ error, setError ] = useState(false);
    const [ searchResult, setSearchResult ] = useState(null);

    const handleSubmit = (e) => {
        e.preventDefault();

        if(surname === '' || programme === '' ) {
            setError('Please fill all the fields.');
            
        } else {
            setError(false);
            // to database
            let student;

            if (students) {
               student = students.filter((stud) => {
                   return stud.surname === surname && stud.classCode === programme
               });
               
               if(student.length === 0 ){
                   setError('No matching results...')
               } else {
                   let data = student[0];
                   setSearchResult(data);
                  // console.log(searchResult);
               }
               
           }
        }

        //console.log(paid, balance, date, term);
    }

    useEffect(() => {
        var elems = document.querySelectorAll('select');
        M.FormSelect.init(elems, {
            dropdownOptions: {
                coverTrigger: false, 
                hover: true
            }
        });

    }, []);
    return ( 
        <BursaryLayout>
            <form className="container row pt-5" onSubmit={handleSubmit} >
               <div className="col s12 m6 l6">
                    <div className="input-field">
                        <input id="surname" type="text" onChange={(e) => setSurname(e.target.value)} value={surname} />
                        <label htmlFor="surname" className="active">Enter Surname :</label>
                    </div>
               </div>
               <div className="col s12 m6 l5 offset-l1">
                    <div className="input-field">
                        <select onChange={(e) => setProgramme(e.target.value)} value={programme}>
                            <option value="" disabled>Select</option>
                                <option value="CV082021 NC1">CV082021 NC1</option>
                                <option value="CV082021 NC2">CV082021 NC2</option>
                                <option value="CV012022 NC3">CV012022 NC3</option>
                                <option value="CV012022 NC4">CV012022 NC4</option>
                                <option value="CV012022 NC5">CV012022 NC5</option>
                                <option value="QS082021 NC1">QS082021 NC1</option>
                                <option value="QS012022 NC2">QS012022 NC2</option>
                                <option value="QS012022 NC3">QS012022 NC3</option>
                                <option value="ARC082021 NC1">ARC082021 NC1</option>
                                <option value="ARC012022 NC2">ARC012022 NC2</option>
                                <option value="ARC012022 NC3">ARC012022 NC3</option>
                                <option value="VAL012022 NC1">VAL012022 NC1</option>
                                <option value="VAL012022 NC2">VAL012022 NC2</option>
                                <option value="IRR012022 NC1">IRR012022 NC1</option>
                                <option value="SG012022 NC1">SG012022 NC1</option>
                                <option value="SG012022 NC2">SG012022 NC2</option>
                                <option value="UB012022 NC1">UB012022 NC1</option>
                                <option value="UB012022 NC2">UB012022 NC2</option>
                                <option value="IT012022 NC1">IT012022 NC1</option>
                                <option value="IT012022 NC2">IT012022 NC2</option>
                                <option value="PS012022 NC1">PS012022 NC1</option>
                                <option value="PS012022 NC2">PS012022 NC2</option>
                                <option value="TM012022 NC1">TM012022 NC1</option>
                                <option value="TM012022 NC2">TM012022 NC2</option>
                                <option value="RM012022 NC1">RM012022 NC1</option>
                                <option value="RM012022 NC2">RM012022 NC2</option>
                                <option value="SS012022 NC1">SS012022 NC1</option>
                                <option value="SS012022 NC2">SS012022 NC2</option>
                                <option value="MM012022 NC1">MM012022 NC1</option>
                                <option value="MM012022 NC2">MM012022 NC2</option>
                                <option value="HR012022 NC1">HR012022 NC1</option>
                                <option value="HR012022 NC2">HR012022 NC2</option>
                                <option value="ACC012022 NC1">ACC012022 NC1</option>
                                <option value="ACC012022 NC2">ACC012022 NC2</option>
                                <option value="HR012022 NC1">HR012022 NC1</option>
                                <option value="HR012022 NC2">HR012022 NC2</option>
                                <option value="ACC012022 NC1">ACC012022 NC1</option>
                                <option value="ACC012022 NC2">ACC012022 NC2</option>
                        </select>
                        <label>Class: </label>
                    </div>
               </div>
               <div className="control">
                    <button
                        className="button is-success mt-3"
                    >
                        <span className="icon">
                            <FaSearch color="white"/>
                        </span>
                        <span className="white-text">Search</span>
                    </button>
                </div>
           </form>
           <div className="container">
                {
                    error && <p className="mt-1 mb-6 main-color-text">{error}</p>
                }
                <h5 className="title is-size-5-touch has-text-weight-semibold mb-2 grey-text text-darken-2">Result:</h5>
                <div className="divider mb-5"></div>
                {
                    searchResult && (
                         <table className="mt-4">
                              <thead>
                                   <tr>
                                        <th>Name</th>
                                        <th className="hide-on-small-only">Date Of Birth</th>
                                        <th className="hide-on-small-only">Gender</th>
                                        <th className="hide-on-small-only">ID No.</th>
                                        <th>Course</th>
                                        <th>Email</th>
                                   </tr>
                                   </thead>
                                   <tbody>          
                                        <tr key={searchResult.idNumber}>
                                             <td>{searchResult.title} {searchResult.forenames} {searchResult.surname}</td>
                                             <td className="hide-on-small-only">{searchResult.dob}</td>    
                                             <td className="hide-on-small-only">{searchResult.gender}</td>    
                                             <td className="hide-on-small-only">{searchResult.idNumber}</td>    
                                             <td>{searchResult.class}</td> 
                                             <td>{searchResult.email}</td>
                                             <td><Link to={`/bursary-students/${searchResult.id}`} className="button is-success is-small">Add Fees</Link></td>
                                        </tr> 
                                   </tbody>
                              </table>
                    )
               } 
           </div>
        </BursaryLayout>
     );
}
 

const mapStateToProps = (state) => {
     //console.log(state);
     return {
         students: state.firestore.ordered.students
     };
 };
  
 export default compose(
     connect(mapStateToProps),
         firestoreConnect((ownProps) => [
             {
                 collection: "students", 
             },
     ])
 )(StudentSearch);